var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Drawer', {
    attrs: {
      "class-name": "member_batch_add",
      "title": $t("9d184c8", "批量设置成员信息"),
      "width": _vm.isMobile ? '90%' : '800px',
      "mask-closable": false,
      "styles": _vm.styles
    },
    on: {
      "on-close": _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "batch_item ivu-form-item"
  }, [_c('div', {
    staticClass: "ivu-form-item-label"
  }, [_vm._v($t("h5542", "成员"))]), _c('ProChiose', {
    attrs: {
      "title": $t("ikz0aw4", "选择成员"),
      "tabs": ['member']
    },
    model: {
      value: _vm.memberCheckedList,
      callback: function ($$v) {
        _vm.memberCheckedList = $$v;
      },
      expression: "memberCheckedList"
    }
  })], 1), _c('div', {
    staticClass: "batch_item ivu-form-item"
  }, [_c('div', {
    staticClass: "ivu-form-item-label"
  }, [_vm._v($t("e6y7m59", "为成员设置（部门）"))]), _c('ProChiose', {
    model: {
      value: _vm.departmemtCheckedList,
      callback: function ($$v) {
        _vm.departmemtCheckedList = $$v;
      },
      expression: "departmemtCheckedList"
    }
  })], 1), _c('div', {
    staticClass: "drawer_footer"
  }, [_c('Button', {
    staticClass: "buttons",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    staticClass: "buttons",
    attrs: {
      "disabled": !_vm._orgIds || !_vm._userIds,
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v($t("e32z2", "保存"))])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };